import { Configuration, PopupRequest } from '@azure/msal-browser'

const {
    REACT_APP_AZURE_AD_CLOUD_INSTANCE_ID,
    REACT_APP_AZURE_AD_CLIENT_ID_YOUGOV,
    REACT_APP_AZURE_AD_TENANT_ID_YOUGOV,
} = process.env

export const msalConfig: Configuration = {
    auth: {
        clientId: `${REACT_APP_AZURE_AD_CLIENT_ID_YOUGOV}`,
        authority: `${REACT_APP_AZURE_AD_CLOUD_INSTANCE_ID}/${REACT_APP_AZURE_AD_TENANT_ID_YOUGOV}`,
        redirectUri: `${window.location.origin}/redirect`,
        postLogoutRedirectUri: `${window.location.origin}`,
    },
    cache: {
        cacheLocation: 'localStorage',
    },
}

export const loginRequest: PopupRequest = {
    scopes: [`api://${process.env.REACT_APP_AZURE_AD_CLIENT_ID_YOUGOV}/access_as_user`],
    prompt: 'select_account',
}
